/**
 * Categories Banners Section - Enhanced Swiper Support
 * rows, slide-mode (page/single) 지원 추가
 */
(function() {
  'use strict';

  function initCategoriesBanners() {
    const sections = document.querySelectorAll('[data-section-name="categories-banners"]');
    
    sections.forEach(section => {
      const sectionId = section.id;
      if (window[sectionId + '_initialized']) return;
      window[sectionId + '_initialized'] = true;

      const swiperElement = section.querySelector('swiper-slider');
      
      if (swiperElement) {
        // Swiper 초기화 전에 설정 오버라이드
        enhanceSwiperConfig(swiperElement);
        // Swiper 초기화 이벤트 감지
        initSwiperObserver(swiperElement);
      }
    });
  }

  /**
   * Swiper 설정 향상 - rows, slidesPerGroup 지원
   */
  function enhanceSwiperConfig(swiperElement) {
    // 원본 configureSwiper를 확장하기 위해 이벤트 리스너 추가
    const rows = parseInt(swiperElement.getAttribute('data-rows')) || 1;
    const rowsMobile = parseInt(swiperElement.getAttribute('data-rows-mobile')) || 1;
    const slidesPerGroup = swiperElement.getAttribute('data-slides-per-group');
    const slidesPerGroupMobile = swiperElement.getAttribute('data-slides-per-group-mobile');
    
    // 원본 configureSwiper 메서드를 오버라이드
    const originalConfigure = swiperElement.configureSwiper;
    if (originalConfigure) {
      swiperElement.configureSwiper = function() {
        originalConfigure.call(this);
        
        // Swiper가 생성된 후 설정 업데이트
        if (this.swiper && this.swiper.params) {
          // Rows 설정 (Grid 모드)
          if (rows > 1) {
            this.swiper.params.grid = {
              rows: rows,
              fill: 'row'
            };
          }
          
          // slidesPerGroup 설정
          if (slidesPerGroup) {
            const spg = parseInt(slidesPerGroup);
            this.swiper.params.slidesPerGroup = spg;
            this.swiper.params.slidesPerGroupAuto = false;
            
            // 모든 breakpoint에도 적용
            Object.keys(this.swiper.params.breakpoints || {}).forEach(bp => {
              this.swiper.params.breakpoints[bp].slidesPerGroup = spg;
              this.swiper.params.breakpoints[bp].slidesPerGroupAuto = false;
            });
          }
          
          // Loop 설정 - rows > 1이면 비활성화
          if (rows > 1) {
            this.swiper.params.loop = false;
          }
        }
      };
    }
    
    // Swiper 초기화 후 설정 재적용
    swiperElement.addEventListener('slide_inited', function() {
      const swiper = this.swiper;
      if (!swiper) return;
      
      // Rows 설정
      if (rows > 1) {
        // Grid 모드는 Swiper 재초기화가 필요할 수 있음
        swiper.params.grid = {
          rows: rows,
          fill: 'row'
        };
        // Loop는 grid 모드에서 비활성화
        swiper.params.loop = false;
        swiper.params.rewind = true;
      }
      
      // slidesPerGroup 설정
      if (slidesPerGroup) {
        const spg = parseInt(slidesPerGroup);
        swiper.params.slidesPerGroup = spg;
        swiper.params.slidesPerGroupAuto = false;
        
        // 현재 breakpoint에 맞게 적용
        const currentBp = swiper.currentBreakpoint;
        if (currentBp && swiper.params.breakpoints[currentBp]) {
          swiper.params.breakpoints[currentBp].slidesPerGroup = spg;
        }
        
        // 모바일 설정
        if (slidesPerGroupMobile && window.innerWidth <= 576) {
          swiper.params.slidesPerGroup = parseInt(slidesPerGroupMobile);
        }
      }
      
      // 설정 업데이트 적용
      try {
        swiper.update();
      } catch(e) {
        console.log('Swiper update warning:', e);
      }
    });
  }

  /**
   * Swiper 초기화 감지 및 최적화
   */
  function initSwiperObserver(swiperElement) {
    // swiper가 이미 초기화되었는지 확인
    if (swiperElement.swiper && swiperElement.swiper.initialized) {
      optimizeSwiper(swiperElement, swiperElement.swiper);
      return;
    }

    // MutationObserver로 swiper 초기화 감지
    const observer = new MutationObserver((mutations, obs) => {
      if (swiperElement.swiper && swiperElement.swiper.initialized) {
        optimizeSwiper(swiperElement, swiperElement.swiper);
        obs.disconnect();
      }
    });

    observer.observe(swiperElement, { 
      attributes: true, 
      childList: true, 
      subtree: true 
    });

    // 타임아웃 폴백 (3초)
    setTimeout(() => {
      observer.disconnect();
      if (swiperElement.swiper) {
        optimizeSwiper(swiperElement, swiperElement.swiper);
      }
    }, 3000);
  }

  /**
   * Swiper 최적화 설정
   */
  function optimizeSwiper(element, swiper) {
    if (!swiper) return;
    
    const rows = parseInt(element.getAttribute('data-rows')) || 1;
    const slidesPerGroup = element.getAttribute('data-slides-per-group');
    
    // rows > 1인 경우 grid 설정 재적용
    if (rows > 1 && swiper.params) {
      swiper.params.grid = {
        rows: rows,
        fill: 'row'
      };
      swiper.params.loop = false;
      swiper.params.rewind = true;
    }
    
    // slidesPerGroup 재적용
    if (slidesPerGroup && swiper.params) {
      swiper.params.slidesPerGroup = parseInt(slidesPerGroup);
      swiper.params.slidesPerGroupAuto = false;
    }
    
    // 슬라이드 변경 시 lazy load 최적화
    swiper.on('slideChangeTransitionEnd', () => {
      if (swiper.lazy) {
        swiper.lazy.load();
      }
    });

    // 초기 업데이트
    try {
      swiper.update();
    } catch(e) {}
  }

  // DOM 준비 시 초기화
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoriesBanners);
  } else {
    initCategoriesBanners();
  }

  // Shopify 섹션 렌더링 이벤트 지원
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-name="categories-banners"]')) {
      const section = event.target.querySelector('[data-section-name="categories-banners"]');
      if (section) {
        delete window[section.id + '_initialized'];
        initCategoriesBanners();
      }
    }
  });
})();